// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"resetFilter_is-mob__b5Bwn","is-desk":"resetFilter_is-desk__jOsmE","container":"resetFilter_container__zEaYZ","container__text":"resetFilter_container__text__s3C5R"};